const pad = (value: number, size = 2): string => String(value).padStart(size, '0');
type DateTimeValue = Date | string | null | undefined;
const isoTimestampPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?Z?$/;

const toDate = (value: DateTimeValue): Date | null => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const getIsoTimestampParts = (value: string): RegExpMatchArray | null => (
  isoTimestampPattern.exec(value)
);

export const formatZuluDateTimeForApi = (value: DateTimeValue): string => {
  if (typeof value === 'string') {
    const match = getIsoTimestampParts(value);
    if (match) {
      const [, year, month, day, hours, minutes, seconds] = match;
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
    }
  }

  const date = toDate(value);
  if (!date) return '';

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const formatZuluDateTimeLabel = (value: DateTimeValue): string => {
  const apiValue = formatZuluDateTimeForApi(value);
  return apiValue ? apiValue.replace('T', ' ') : '';
};

export const formatDatePickerZuluDateTimeForApi = (value: Date | null | undefined): string => {
  if (!value || Number.isNaN(value.getTime())) return '';

  const year = value.getFullYear();
  const month = pad(value.getMonth() + 1);
  const day = pad(value.getDate());
  const hours = pad(value.getHours());
  const minutes = pad(value.getMinutes());
  const seconds = pad(value.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const formatDatePickerZuluDateTimeLabel = (value: Date | null | undefined): string => {
  const apiValue = formatDatePickerZuluDateTimeForApi(value);
  return apiValue ? apiValue.replace('T', ' ') : '';
};

export const formatZuluGridDateTime = (value: DateTimeValue): string => {
  if (typeof value === 'string') {
    const match = getIsoTimestampParts(value);
    if (match) {
      const [, year, month, day, hours, minutes, seconds] = match;
      return `${month}/${day}/${year.slice(2)} ${hours}:${minutes}:${seconds}Z`;
    }
  }

  const date = toDate(value);
  if (!date) return '';

  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const year = String(date.getUTCFullYear()).slice(2);
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}Z`;
};